export default __webpack_public_path__ + "static/media/Front-Mr-Houssam-Obadi-Apartment.14644fc1.jpg";